import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tomorrowBtn", "calendarBtn", "tomorrowPanel", "calendarPanel"]

  connect() {
    // Restore last viewed panel from localStorage
    const lastPanel = localStorage.getItem("plannerRightPanel")
    if (lastPanel === "calendar") {
      this.showCalendar()
    } else {
      this.showTomorrow()
    }
  }

  showTomorrow() {
    this.tomorrowPanelTarget.classList.remove("hidden")
    this.calendarPanelTarget.classList.add("hidden")
    this.tomorrowBtnTarget.classList.add("active")
    this.calendarBtnTarget.classList.remove("active")
    localStorage.setItem("plannerRightPanel", "tomorrow")
  }

  showCalendar() {
    this.tomorrowPanelTarget.classList.add("hidden")
    this.calendarPanelTarget.classList.remove("hidden")
    this.tomorrowBtnTarget.classList.remove("active")
    this.calendarBtnTarget.classList.add("active")
    localStorage.setItem("plannerRightPanel", "calendar")
  }
}
